import { render, staticRenderFns } from "./MySvgIcon.vue?vue&type=template&id=c0d0f9b6&"
import script from "./MySvgIcon.vue?vue&type=script&lang=js&"
export * from "./MySvgIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports